module.exports = __webpack_public_path__ + "static/media/303ButtonLabel--clear.ac0fd2a5.svg";